import { useEffect, useState } from "react";
import { api } from "@/lib/api";

let metaCache = null;

export function useMeta() {
  const [meta, setMeta] = useState(metaCache);
  const [entities, setEntities] = useState([]);
  useEffect(() => {
    if (!metaCache) api.get("/categories").then(({ data }) => { metaCache = data; setMeta(data); }).catch(() => {});
    api.get("/entities").then(({ data }) => setEntities(data)).catch(() => {});
  }, []);
  const reloadMeta = () => api.get("/categories").then(({ data }) => { metaCache = data; setMeta(data); });
  const reloadEntities = () => api.get("/entities").then(({ data }) => setEntities(data));
  return { meta, entities, reloadMeta, reloadEntities };
}
